export default __webpack_public_path__ + "static/media/4044971.62c68f8d.jpg";